import http from '@/services/http';
import errorHandlers from '@/services/error-handlers';
import parseYourPayment from '@/helpers/parse-your-payment';


export default {
  namespaced: true,

  state: {
    isLoading: false,
    orders: [],
    ratingsForOrders: {}
  },

  getters: {
    orderHistory(state) {
      const parsedOrders = [];

      state.orders.forEach((order) => {
        const ticketNumber = order.ticketNumber || order.orderId.toString().substr(-3);
        let { tip } = order;
        let total = order.total + order.tip;
        let isCompleted = false;
        let orderItemCount = 0;
        const yourPayment = parseYourPayment(order.payments);
        const {
          delivery = {
            fee: 0,
            tip: 0
          },
          shipment = {
            fee: 0
          }
        } = order;

        const surchargeAmount = order.payments.find(payment => payment.surcharge)?.surcharge;
        if (surchargeAmount) total += surchargeAmount;

        if (order.fulfillmentType === 'Delivery') {
          const deliveryDate = new Date(delivery.estimatedDeliveryTime);
          isCompleted = deliveryDate.getTime() <= Date.now();
          tip += delivery.tip;
          total += delivery.fee;
          total += delivery.tip;
        }

        else if (order.fulfillmentType === 'DineIn') {
          isCompleted = true;
        }

        else if (order.fulfillmentType === 'Shipping') {
          isCompleted = true;
          total += shipment.fee;
        }

        else {
          const pickupDate = new Date(order.pickupDate);
          isCompleted = pickupDate.getTime() <= Date.now();
        }

        order.orderItems.forEach((item) => {
          orderItemCount += item.quantity;
        });

        const parsedOrderData = {
          ...order,
          isCompleted,
          orderItemCount,
          ticketNumber,
          tip,
          total,
          yourPayment
        };

        parsedOrders.push(parsedOrderData);
      });

      const history = { ...state, parsedOrders };

      return history;
    }
  },

  actions: {
    async getOrders({ commit }) {
      try {
        commit('SET_LOADING_STATUS', true);

        const response = await http.get('/cardfree-api/v1/account/me/order');

        commit('SET_ORDERS', response.data.data);
      }

      catch (error) {
        errorHandlers.generic(error);
      }

      finally {
        commit('SET_LOADING_STATUS', false);
      }
    },

    async submitOrderItemRating({ state, commit }, { rating, orderId, menuItemId }) {
      try {
        const requestBody = { rating };

        await http.post(`/cardfree-api/v1/account/me/order/${orderId}/menu-item/${menuItemId}/rating`, requestBody);

        const { ratingsForOrders } = state;

        const existingOrder = ratingsForOrders[orderId];

        const commitPayload = { ...ratingsForOrders };

        if (existingOrder) {
          const updatedMenuItemRating = {
            ...existingOrder,
            [menuItemId]: { rating }
          };

          Object.assign(commitPayload, { [orderId]: updatedMenuItemRating });
        }
        else {
          const newMenuItemRating = {
            [menuItemId]: { rating }
          };

          Object.assign(commitPayload, { [orderId]: newMenuItemRating });
        }

        /**
         * Note: Create a temporary "memoized" object of orderId's with corresponding menu item id's and their ratings,
         * so when a user updates their rating the UI stores the rating without having to re-fetch the order history data.
         */
        commit('SET_RATINGS_FOR_ORDERS', commitPayload);
      }
      catch (error) {
        throw error;
      }
    }
  },

  mutations: {
    SET_ORDERS(state, orders) {
      state.orders = orders || [];
    },

    SET_LOADING_STATUS(state, isLoading) {
      state.isLoading = isLoading;
    },

    SET_RATINGS_FOR_ORDERS(state, ratingsForOrders = {}) {
      state.ratingsForOrders = ratingsForOrders;
    }
  }
};
